'use strict'

let self

export default self = {
  video : document.querySelector('.reports-video video'),
  btnPlay : document.querySelector('.reports-video button.btn-watch'),
  btnPause : document.querySelector('.reports-video button.btn-pause'),

  init : () => {
    self.btnPlay.addEventListener('click', self.fadeOutStart);
    self.btnPause.addEventListener('click', self.fadeInPause);
  },

  fadeOutStart : () => {
    document.body.classList.add('is-cover-fade');
    setTimeout(()=>self.video.play(), 400);
  },

  fadeInPause : () => {
    document.body.classList.remove('is-cover-fade');
    self.video.pause();
  }

}
